import React from 'react';

const Folder: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM20 11H4V19H20V11ZM20 9V7H11.586L9.586 5H4V9H20Z" />
  </>
);

export default Folder;
